import React, { Component } from 'react'
import BlockUi              from 'react-block-ui'
import { message, Modal }   from 'antd'

import CloudFlyerAPI               from '../../../api/CloudFlyerAPI'
import {DEFAULT_CONTENT_LIMIT,} from '../../../actions/cloud-files-system-actions'
import { play_file }            from '../../../actions/video-player'

import Header              from '../Controls/header'
import Search              from '../Controls/search'
import NavigationControls  from '../Controls/navigation-controls'
import Files               from './files'
import Share               from '../../FilesShare/share'
import CreateFolder        from '../Controls/create-folder'
import Encode              from '../../Encoding/EncodeView'

import uploadService       from '../Local/S3/s3'
import prettysize          from '../../../utils'
import Payment             from "payment"
import PaymentForm         from '../../Billing/PaymentForm'
import MediaInfo           from "../../MediaInfo"
import CreateHybrikJob     from '../../../views/Hybrik/CreateJob'
import {sanitize_path,
    get_previous_path, parseUrl}       from "../../../utils"

import 'react-block-ui/style.css'
import './styles.scss'

export default class CloudFilesSystem extends Component {

    constructor (props) {
        super(props)

        this.side = props.side
        this.state = {
            bucket              : props.bucket,
            cloud               : props.cloud,
            cloud_accounts      : [],
            content_limit       : DEFAULT_CONTENT_LIMIT,
            files               : [],
            download_files      : [],
            expand_bulk_options : false,

            has_more_files      : false,

            previous_path      : null,
            current_path       : '/',
            last_file          : null,

            share_recipients   : [],
            share_select_all   : true,
            share_files        : [],

            encoding           : {
                path :'',
                bucket:'',
                preset :'',
                category : '',
                price_per_gb: 0.50
            },

            encode_files       : null,
            encode_visible     : false,
            encode_presets     : [],
            encode_directories : [],

            create_folder      : false,
            new_folder_name    : '',

            accounts_loading   : false,
            files_loading      : false,
            encode_loading     : false,
            share_loading      : false,
            search_loading     : false,
            new_folder_loading : false,
            selection_count    : 0,
            error              : null,

            slack_channels     : [],
            slack_channel      : '',
            share_on_slack     : '',
            share_expiration   : 604800,

            selection : {
                size       : 0,
                cost       : 0.0003,
                total_cost : 0,
                count      : 0
            },

            billing_modal_visible : false,
            billing_loading       : false,
            billing_valid         : false,
            focused               : '',
            billing :{
                number: '',
                name: '',
                exp: '',
                cvc: ''
            }
        }

        this.uploadService = new uploadService()
    }

    componentDidMount() {
        this.props.fetchCloudAccounts()
    }

    componentWillReceiveProps(props) {
        let bucket = this.state.bucket
        this.setState({
            bucket         : props.bucket,
            cloud          : props.cloud,
            cloud_accounts : props.clouds
        }, ()=> {
            if(this.props.bucket && (this.props.bucket.id !== (bucket||{}).id))
                this.props.bucket.first_loaded = false
            if(this.props.bucket && (this.props.bucket.id !== (bucket||{}).id || !this.props.bucket.first_loaded))
            {
                this.props.bucket.first_loaded = true
                this.browse(this.props.bucket, {})
            }
        })
    }

    componentDidCatch(err, details){
        console.error(err, details)
    }

    browse = (bucket, {previous_path, current_path, content_limit, last_file}, loadMore) =>{
        if(!bucket)
            return

        let $this = this
        $this.setState({
            last_file     : null,
            create_folder : false,
            has_more_files: false,
            files_loading : true,
            error         : null
        }, ()=> this.props.on_browse(sanitize_path(current_path)))

        const alreadyExistFiles = this.state.files

        const continuation_token = this.state.continuation_token

        CloudFlyerAPI
            .storages
            .getFilesByPath(bucket.id, current_path ? current_path : '/', content_limit ? content_limit : DEFAULT_CONTENT_LIMIT, last_file, continuation_token)
            .then(({data:{items=[], last_file:res_last_file, path:res_path, continuation_token: next_continuation_token}={}}) => {

                const files = JSON.parse(JSON.stringify(items).replace(/=/g, ''))
                const newFiles = (files && loadMore) ? alreadyExistFiles.concat(files) : files

                let has_more_files = files.length === DEFAULT_CONTENT_LIMIT
                let last_file      = has_more_files ? items[items.length-1] : null
                last_file          = last_file ? last_file.basename : null
                let {bucket:current_bucket={}} = $this.state

                //todo handle more files
                //let files = props.files_loading ? this.state.files : (props.more_files ? this.state.files.concat(props.more_files) : props.files)

                $this.setState({
                    continuation_token: next_continuation_token,
                    files: newFiles,
                    last_file,
                    has_more_files,
                    bucket,

                    current_path  : sanitize_path(current_bucket ? (res_path ? res_path : '') : current_path),
                    previous_path : current_bucket ? (get_previous_path(res_path)) : previous_path,
                    more_files    : (res_last_file && res_last_file !== last_file) ? newFiles : null,

                    files_loading : false,
                    error         : null,
                    content_limit
                }, ()=> this.props.file_selection_changed && this.props.file_selection_changed(this.state.files))
            })
            .catch(err => {
                $this.setState({
                    files         : [],
                    files_loading : false,
                    error         : err.message,

                    current_path,
                    content_limit,
                    last_file
                })
            })
    }

    on_load_more = () =>{
        console.log('load more please !')
        let $this =this
        if($this.state.files_loading || !$this.state.has_more_files){
            return
        }
        $this.setState({files_loading: true}, ()=> $this.browse($this.props.bucket, $this.state, true))
    }

    on_delete = file =>{
        let $this = this
        let file_names = []

        if(file && !file.checked){
            file_names.push(file.path)
        } else {
            for (let i = 0; i < this.state.files.length; i++) {
                let fl = this.state.files[i];
                if(fl.checked){
                    file_names.push(fl.path)
                }
            }
        }

        this.setState({delete_loading:true})

        CloudFlyerAPI
            .transfer
            .delete_object(this.props.bucket.cloud_account_id, this.props.bucket.bucket_name, file_names)
            .then(response => {
                $this.setState({delete_loading: false})
                if(!(response||{}).data){
                    return message.error('failed to delete files, please retry again')
                }

                message.success((response||{}).data.message||'')
                $this.browse($this.props.bucket, $this.state)
            })
            .catch(err=> {
                $this.setState({
                    delete_loading: false
                })
                message.error(err)
            })
    }

    on_download = file =>{
        let $this = this
        $this.setState({
            dl_loading: true
        })

        let file_names = []

        if(file && !file.checked)
            file_names.push(file.path)
        else
            for (let i = 0; i < $this.state.files.length; i++) {
                let fl = $this.state.files[i]
                if(fl.checked){
                    file_names.push(fl.path)
                }
            }

        if($this.props.on_download)return this.props.on_download(this.props.bucket.cloud_account_id, this.props.bucket.bucket_name, file_names)

        CloudFlyerAPI
            .transfer
            .download_url($this.props.bucket.cloud_account_id, $this.props.bucket.bucket_name, file_names)
            .then(res => {
                $this.setState({dl_loading: false})

                if(!((res||{}).data||{}))return message.error('failed to generate download link, please retry again');

                if(((res||{}).data||{}).length === 1){
                    let {pathname=''} = parseUrl(((res||{}).data||{})[0].url)
                    if(pathname.endsWith('.pdf') || pathname.endsWith('.jpg')) return window.open(((res||{}).data||{})[0].url, '_self')
                }

                $this.setState({
                    download_files:[]
                }, ()=> $this.setState({
                    download_files:((res||{}).data||{})
                }))
            }).catch(err=> {
            $this.setState({
                dl_loading: false
            })
            message.error(((err.response||{}).data||{}).message)
        })
    }

    on_select = (file, checked) =>{
        for (let key in this.state.files) {
            let item = this.state.files[key]
            if(item.basename === file.basename && item.type === 'FS_FILE_TYPE_FILE'){
                item.checked = checked
                return this.setState({
                    files:this.state.files,
                    selection_count:this.state.files.filter(_=>_.checked).length
                }, ()=> {
                    this.props.file_selection_changed && this.props.file_selection_changed(this.state.files)
                    this.props.cloud_selection_changed(this.calculate_selection())
                })
            }
        }
    }

    calculate_selection = () => {
        let files = this.state.files.filter((f) => f.checked && f.type === 'FS_FILE_TYPE_FILE')
        let selection = {
            size       : 0,
            cost       : 0.0003,
            total_cost : 0,
            count      : 0
        }

        for (let key in files) {
            let file = files[key]

            selection.size       += file.size
            selection.count      += 1
            selection.total_cost += selection.cost * (file.size/(1024*1024*1024))
        }

        this.setState({
            selection: selection
        })
        return selection
    }

    on_expand_options = file =>{
        for (let key in this.state.files) {
            let item = this.state.files[key]
            if(item.basename === file.basename){
                item.expand_options = !file.expand_options
            } else {
                item.expand_options = false
            }
        }

        this.setState({
            files : this.state.files
        })
    }

    on_navigate_back = () => {
        this.setState({
            current_path       : this.state.previous_path,
            last_file          : null,
            continuation_token : null
        }, ()=> this.browse(this.props.bucket, this.state))
    }

    on_navigate = file =>{
        this.setState({
            current_path       : file.path,
            last_file          : null
        }, ()=> this.browse(this.props.bucket, this.state))
    }

    on_share = file =>{
        let $this = this
        let files = []

        if(file){
            file.share = true
            files.push(file)
        } else {
            files = $this.state.files.filter(f=> f.type === 'FS_FILE_TYPE_FILE')
            if(files.filter(f=> f.checked).length > 0){
                files = files.filter(f=> f.checked)
            }
        }

        for (let key in files){
            files[key].share = true
        }

        $this.setState({
            share_visible    : true,
            share_select_all : true,
            share_files      : files
        }, ()=>{
            CloudFlyerAPI.slack
                .channels()
                .then(({data:slack_channels}) => $this.setState({slack_channels}, ()=> $this.props.refresh_profile(true)))
                .catch(console.warn)
        })
    }

    on_share_cancel  = () => this.setState({share_visible: false})

    on_share_select  = (file, share) =>{
        for (let key in this.state.share_files) {
            let item = this.state.share_files[key]
            if(item.basename === file.basename){
                item.share = share
                this.setState({
                    share_files : this.state.share_files,
                    share_select_all : false
                })
                return
            }
        }
    }

    on_copy_link     = file =>{
        if (!file) {
            return
        }

        try {
            let textArea              = document.createElement("textarea");
            textArea.style.position   = 'fixed';
            textArea.style.top        = 0;
            textArea.style.left       = 0;
            textArea.style.width      = '2em';
            textArea.style.height     = '2em';
            textArea.style.padding    = 0;
            textArea.style.border     = 'none';
            textArea.style.outline    = 'none';
            textArea.style.boxShadow  = 'none';
            textArea.style.background = 'transparent';
            textArea.value            = file.download_url;
            document.body.appendChild(textArea);
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
        } catch (e) {}

        message.success('Link copied!')
    }

    on_generate_link = file =>{
        let $this = this
        file.generating_link = true

        CloudFlyerAPI.transfer.download_url($this.props.bucket.cloud_account_id, $this.props.bucket.bucket_name, [file.path])
            .then(response => {
                file.generating_link = false

                if(!(response||{}).data){
                    return message.error('failed to generate download link, please retry again');
                }

                file.download_url = (response||{}).data[0].url
                $this.setState({files:this.state.files})
                message.success('Link generated !')
            })
            .catch(err=> {
                file.generating_link = false
                file.download_url    = null
                $this.setState({files:this.state.files})
                message.error(err)
            })
    }

    on_share_files = files =>{
        let $this = this
        $this.setState({share_loading: true})

        let share_files = []

        for (let key in files){
            share_files.push({
                    name             : files[key].path,
                    size             : files[key].size,
                    acl              : 'private',
                    bucket_name      : $this.props.bucket.bucket_name,
                    cloud_account_id : $this.props.bucket.cloud_account_id
                }
            )
        }

        if(share_files.length <= 0)
            return

        if($this.state.slack_channel){
            CloudFlyerAPI
                .transfer
                .share_by_slack_files(share_files, $this.state.slack_channel)
                .then(()=> $this.setState({share_visible:false, share_loading:false}))
                .catch(console.error())
        }

        if($this.props.use_weblink){
            return CloudFlyerAPI
                .file_catalyst
                .transfers
                .share(share_files.map(f=> ('/' + f.bucket_name + '/' + f.name).replace(/([^:]\/)\/+/g, "$1")), $this.state.share_recipients, $this.props.connection_key)
                .then(()=> {
                    $this.setState({
                        share_visible: false,
                        share_loading : false
                    })
                    message.success('files shared successfully')
                })
                .catch(err =>{
                    $this.setState({share_loading: false})
                    message.error(err.message)
                })
        }

        if($this.state.share_recipients.length <= 0)
            return
        CloudFlyerAPI
            .transfer
            .share_by_email_files({
                files      : share_files,
                recipients : $this.state.share_recipients,
                password   : $this.state.share_password,
                expiration : $this.state.share_expiration
            })
            .then(()=> {
                $this.setState({
                    share_visible : false,
                    share_loading : false
                })
                message.success('files shared successfully')
            })
            .catch(err =>{
                $this.setState({share_loading: false})
                message.error(err.message)
            })
    }

    on_share_password_change = ({ target }) => this.setState({share_password: target.value})

    on_share_expiration_change = value => this.setState({share_expiration: value})

    on_recipient_change = (recipients) =>
        this.setState({share_recipients: recipients})

    on_share_select_all = (check_all)=> {
        for (let key in this.state.files){
            this.state.files[key].share = check_all
        }

        this.setState({
            files            : this.state.files,
            share_select_all : check_all
        })
    }

    on_encode  = files =>{
        let $this = this
        if(files.length === 0){
            return
        }

        if(files.length <= 0){
            return message.warn('Please select a file to encode')
        }

        let all_encodes = [].concat(...files.map(f=> f.presets))

        for (let key in all_encodes) {
            let encode = all_encodes[key]

            if(!encode.destination.bucket_name || !encode.destination.cloud_account_id){
                return message.warn('Please select a destination path')
            }

            if(!encode.category || !encode.preset){
                return message.warn('Please select a preset for ' + encode.source.path + ' (' + encode.preset + ') and ' + encode.destination.path)
            }
        }

        let total_size = files.map(f => f.size * f.presets.length).reduce((prev, curr) => prev + curr)
        let {quota:{encoding:{trial={total:0, used:0}}}={}, has_billing_info, role={}} = $this.props.user

        if(!has_billing_info && total_size > (trial.total - trial.used)){
            if(role.title !== 'Owner'){
                return Modal.warning({
                    title:'Encoding Quota Limit',
                    content:(
                        <div>
                            <p>Please contact account owner to add Credit Card information to your organization.</p>
                            <p>You have {prettysize(trial.total - trial.used)} remaining on your quota.</p>
                        </div>
                    ),
                    onOk:()=> $this.props.refresh_profile(true)
                })
            }
            return $this.setState({
                billing_modal_visible:true}, ()=>{
                if(document.querySelector('[name="number"]')){
                    //Payment.formatCardNumber(document.querySelector('[name="number"]'))
                    /*Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))*/
                    Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
                }
            })
        }

        $this.setState({encode_loading:true})

        CloudFlyerAPI
            .encoding
            .encode(all_encodes)
            .then(()=> {
                $this.setState({
                    encode_visible: false,
                    encode_loading : false
                })
                message.success('You files have been adding to the queue successfully')
            })
            .catch((err)=>{
                $this.setState({encode_loading: false})
                message.error(err.message)
            })
    }

    on_open_encode = file =>{
        let files = []

        if(file){
            files.push(file)
        } else {
            files = this.state.files.filter(f=> f.type === 'FS_FILE_TYPE_FILE')
            if(files.filter(f=> f.checked).length > 0){
                files = files.filter(f=> f.checked)
            }
        }

        files.map(f=> {
            f.full_path         = this.state.current_path
            f.bucket_name       = this.props.bucket.bucket_name
            f.cloud_account_id  = this.props.bucket.cloud_account_id

            f.source = {
                cloud_account_id : this.props.bucket.cloud_account_id,
                bucket_name      : this.props.bucket.bucket_name,
                path             : f.path
            }

            f.presets           = []
            f.add_coder_visible = false
            return f
        })

        let options = this.state.cloud_accounts.map(c=> {
            return {
                value: c.project_name,
                label: c.project_name,
                children : c.storages.map(s =>{
                    return {
                        value  : s.id,
                        label  : s.bucket_name,
                        isLeaf : false,
                        is_bucket : true,
                        id : s.id
                    }
                })
            }
        })

        this.setState({
            encode_visible     : true,
            encode_loading     : false,
            encode_files       : files,
            encode_directories : options,
            encodingService: ''
        }, ()=>{
            CloudFlyerAPI.encoding
                .presets()
                .then(res => {
                    let encode_presets = ((res||{}).data||{}).transcode_presets
                        .map((format, index) =>({
                            id     : index,
                            name   : format.category,
                            presets: format.presets.map(preset=> ({
                                value: format.category + '-' + preset.name,
                                name : preset.name
                            }))
                        }))

                    let first_category = (encode_presets[0]||{}).name
                    let first_preset   = ((encode_presets[0]||{}).presets[0]||{}).name

                    files.map(f=> {
                        f.category = first_category
                        f.preset   = first_preset

                        /*f.presets           = [{
                          category : first_category,
                          preset   : first_preset,

                          destination: {
                            cloud_account_id : f.cloud_account_id,
                            bucket_name      : f.bucket_name,
                            path             : f.full_path
                          },

                          source:f.source
                        }]*/
                        return f
                    })

                    this.setState({encode_presets})
                })
                .catch(err=> {
                    console.error(err)
                    message.error(err.message)
                })
        })
    }

    on_close_encode  = () => this.setState({encode_visible: false})

    on_directory_change  = (file, values, options) => {
        let directory = options[options.length - 1].is_bucket ? {id : options[options.length - 1].id} : options[options.length - 1]

        if(directory && directory.id){
            file.cloud_account_id = directory.id.split('/')[0] || ''
            file.bucket_name      = directory.id.split('/')[1] || ''
            file.full_path        = directory.value || ''

            this.setState({})
        } else {
            file.cloud_account_id = ''
            file.bucket_name      = ''
            file.full_path        = ''

            this.setState({})
        }
    }

    on_add_codec = (file, add) =>{
        if(!file)
            return
        if(add)
            file.presets.push({
                category : file.category,
                preset   : file.preset,

                destination: {
                    cloud_account_id : file.cloud_account_id,
                    bucket_name      : file.bucket_name,
                    path             : file.full_path
                },
                source:file.source
            })
        file.add_coder_visible = !file.add_coder_visible
        this.setState({})
    }

    on_add_coder_change = (file, from_button) =>{
        if(!from_button)
            return
        file.add_coder_visible = !file.add_coder_visible
        this.setState({})
    }

    on_preset_change  = (file, new_preset) =>{
        if(file && new_preset){
            let category = new_preset.split('-')[0]
            let preset   = new_preset.split('-')[1]

            file.category = category
            file.preset   = preset
            this.setState({})

            //this.setState({encode_preset: new_preset, encoding:{...this.state.encoding, preset:set, category}})
        } else {
            file.category = ''
            file.preset   = ''
            this.setState({})

            //this.setState({encode_preset: new_preset, encoding:{...this.state.encoding, category:'', preset:''}})
        }
    }

    on_remove_preset = (file, preset)=>{
        if(!file || !preset)
            return
        file.presets = file.presets.filter(p=> !(p.preset === preset.preset &&
            p.category === preset.category &&
            p.destination.cloud_account_id === preset.destination.cloud_account_id &&
            p.destination.bucket_name === preset.destination.bucket_name &&
            p.destination.path === preset.destination.path)) || []
        this.setState({})
    }

    load_directories = directory =>{
        let $this = this
        const target_directory   = directory[directory.length - 1]
        target_directory.loading = true

        CloudFlyerAPI
            .storages
            .directories(target_directory.id, target_directory.is_bucket ? '' : target_directory.value)
            .then(({data:{items, out, id, bucket_name, path}}) => {
                target_directory.loading  = false
                target_directory.isLeaf   = items.length === 0
                target_directory.children = target_directory.isLeaf ? null : items.map(path => ({
                    label  : path,
                    value  : path,
                    isLeaf : false,
                    id     : target_directory.id
                }))

                $this.setState({
                    encode_directories : [...$this.state.encode_directories],
                    encode_directory   : path
                })
            })
            .catch((err)=>{
                target_directory.loading = false
                message.error(err.message)
            })
    }

    on_create_folder = new_folder_name => {
        if(!new_folder_name){
            return this.setState({
                create_folder : true
            })
        }

        let $this = this
        this.setState({
            new_folder_loading : true
        })
        CloudFlyerAPI
            .transfer
            .create_folder(this.props.bucket.cloud_account_id, this.props.bucket.bucket_name, (this.state.current_path||'') + '/' + new_folder_name)
            .then(()=> $this.setState({
                new_folder_loading : false,
                create_folder : false
            }, ()=> $this.browse(this.props.bucket, this.state)))
            .catch(err=> $this.setState({
                new_folder_loading : false
            }, ()=> message.error(err.message)))
    }

    on_cancel_create_folder= ()=>
        this.setState({
            create_folder: false
        })

    on_new_folder_name_change = (new_folder_name) => this.setState({new_folder_name: new_folder_name})

    on_focus = target =>
        this.setState({
            focused: target.name,
        })

    on_billing_change = target => {
        const billing = this.state.billing

        if (target.name === 'number') {
            billing[target.name] = target.value.replace(/ /g, '')
        }
        else if (target.name === 'expiry') {
            billing[target.name] = target.value.replace(/[ \/]/g, '')
        }
        else {
            billing[target.name] = target.value
        }

        this.setState({
            billing: billing
        })
    }

    billing_callback = (type, isValid) => this.setState({billing_valid: isValid})

    on_cancel_billing = () => this.setState({billing_modal_visible: false})

    on_save_billing = () => {
        this.form.validateFields((err, values) => {
            if (err) {
                return message.error('Please fill required fields')
            }

            this.setState({billing_loading: true})

            const { name, number, expiry, cvc } = values
            let {email, first_name, last_name} = this.props.user

            let subscription = {
                customer_subscription: {
                    subscription: {
                        product_handle : 'CloudFlyer-free',
                        coupon_code    : '',

                        customer_attributes: {
                            first_name : first_name,
                            last_name  : last_name,
                            email      : email
                        },

                        credit_card_attributes: {
                            full_number      : number,
                            expiration_month : expiry.split('/')[0],
                            expiration_year  : expiry.split('/')[1],
                            billing_address  : '',
                            billing_city     : '',
                            billing_state    : '',
                            billing_country  : 'USA',
                            billing_zip      : ''
                        }
                    }
                }
            }

            CloudFlyerAPI.billing.subscriptions
                .new_customer(subscription)
                .then(()=> {
                    this.setState({billing_loading: false, billing_modal_visible:false}, ()=>{
                        this.props.refresh_profile()
                        message.success('Subscribed successfully')
                    })
                })
                .catch(function (err) {
                    this.setState({billing_loading: false}, ()=> this.props.refresh_profile(true))

                    if(((err.response||{}).data||{})){
                        if(((err.response||{}).data||{}).chargify_errors){
                            return message.error(((err.response||{}).data||{}).chargify_errors[0])
                        }
                        message.error(((err.response||{}).data||{}).message)
                    } else {
                        message.error(err.message)
                    }
                })
        })
        this.props.refresh_profile(true)
    }

    on_play_video = file => this.props.dispatch(play_file(this.props.bucket.cloud_account_id, this.props.bucket.bucket_name, file.path))

    on_slack_channel_change = slack_channel => this.setState({slack_channel})

    on_open_hybrik = file => {
        file.full_path = this.state.current_path
        file.bucket_name = this.props.bucket.bucket_name
        file.cloud_account_id = this.props.bucket.cloud_account_id
        file.source = {
            cloud_account_id : this.props.bucket.cloud_account_id,
            bucket_name      : this.props.bucket.bucket_name,
            path             : file.path
        }
        file.endpoint = this.state.cloud.endpoint || null

        let options = this.state.cloud_accounts.map(c=> {
            return {
                value: c.project_name,
                label: c.project_name,
                children : c.storages.map(s =>{
                    return {
                        value  : s.id,
                        label  : s.bucket_name,
                        isLeaf : true,
                        is_bucket : true,
                        id : s.id,
                        children:null
                    }
                })
            }
        })

        this.setState({
            hybrik_visible     : true,
            hybrik_file        : file,
            encode_directories : options
        }, ()=>{
            CloudFlyerAPI
                .hybrik
                .fetchProfiles()
                .then(({data}) => this.setState({profiles: data}))
                .catch(console.error)
        })
    }

    on_close_hybrik = () => {
        this.setState({
            hybrik_visible: false,
            definitions: null,
            profile_id: null
        })
    }

    on_profile_change = value => {
        const { definitions } = this.state.profiles.find(p => p.id === value)
        const { hybrik_file } = this.state
        if(definitions.source) {
            definitions.source = `s3://${hybrik_file.bucket_name}/${hybrik_file.path}`
        }
        this.setState({
            profile_id: value,
            definitions
        })
    }

    on_def_change = ({ target }) => {
        this.setState({
            definitions: {
                ...this.state.definitions,
                [target.name]: target.value
            }
        })
    }

    on_hybrik_encode = () => {
        let $this = this
        const { profile_id, definitions,
            hybrik_file: { cloud_account_id, endpoint } } = $this.state
        const { provider: account_type } = $this.props
        if(definitions.destination) {
            definitions.destination = definitions.destination.replace(/\/$/, "")
        }
        CloudFlyerAPI
            .hybrik
            .createJob({
                profile_id,
                definitions,
                cloud_account_id,
                account_type,
                endpoint
            })
            .then(() => {
                message.success('Job created successfully.')
                $this.setState({ hybrik_visible: false })
            })
            .catch(() => {
                message.error('Unable to start the job, please try again later.')
            })
    }

    on_dest_change = ([cloud_account_id, bucket_id, path = '']) => {
        const { definitions } = this.state
        if (definitions && definitions.destination && bucket_id) {
            const bucket_name = bucket_id.split('/')[1]
            definitions.destination = `s3://${bucket_name}/${path}`
            this.setState({ definitions })
        }
    }

    on_show_media_info = file => this.media_info.open({
        ...file, ...{
            bucket_name: this.props.bucket.bucket_name,
            cloud_account_id: this.props.bucket.cloud_account_id
        }
    })

    on_search_toggle = () => this.setState(({search_visible}) => ({search_visible: !search_visible}))

    on_search = keyword =>{
        let $this = this
        const {bucket:{bucket_name}, cloud:{id}, path} = $this.props
        $this.setState({search_loading:true})
        CloudFlyerAPI
            .storages
            .search({
                keyword,
                config:{
                    path           : path||'/',
                    bucket         : bucket_name,
                    cloud_accounts : [id]
                }
            })
            .then(({data:{count=0, results=[]}={}}) => $this.setState({files: results, search_loading: false}))
            .catch(err => {
                console.error(err)
                $this.setState({search_loading:false})
                message.error(err.message)
            })
    }

    on_move_files = (target, paths, is_copy) =>{
        if(!target || !paths)
            return
        const {bucket_name, cloud_account_id} = this.props.bucket

        this.props.refresh_rm()
        target.open(paths, ({id:dest_id, bucket_name:dest_bucket_name, bucket_id:dest_bucket_id, path:dest_path})=>{
            CloudFlyerAPI
                .transfer
                .migration
                .moveAWS({
                    files:paths.map(path=>({
                        path        : path.path,
                        bucket_name : bucket_name
                    })),
                    type:is_copy ? 'copy':'move',
                    cloud_id:cloud_account_id,
                    destination:{cloud_id:dest_id, bucket_name:dest_bucket_name, bucket_id:dest_bucket_id, path:sanitize_path(dest_path)}
                })
                .then(()=>this.props.clear_migration(null, target.on_cancel))
                .catch(err=> {
                    target.on_loading(false)
                    console.dir(err)
                    message.error((((err.response||{}).data||{}).message) || 'An error occurred while trying to enqueue the transfer, please try again')
                })
        })
    }

    add_files = (items=[], index) =>{
        let files = this.state.files
        files.splice(index, 0, ...JSON.parse(JSON.stringify(items)))
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
            {
                files[key].pasted = true
                files[key].checked = false
            } else
                files[key].pasted = files[key].checked = false
        }
        this.setState({files}, ()=> this.props.file_selection_changed && this.props.file_selection_changed(this.state.files))
    }

    remove_files = (items=[]) =>{
        let files = this.state.files
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
                delete files[key]
        }
        this.setState({files}, ()=> this.props.file_selection_changed && this.props.file_selection_changed(this.state.files))
    }

    reorder = (items=[], index, index_dest) =>{
        let files = this.state.files
        for (let key in files) {
            if(items.some(e => e.path === files[key].path))
            {
                const [removed] = files.splice(index, 1)
                files.splice(index_dest, 0, removed)
            }
        }
        this.setState({files})
    }

    render() {
        const {new_folder_loading, accounts_loading, files_loading, files, bucket, cloud_accounts, create_folder, hybrik_visible, search_loading }        = this.state
        const {encode_files, encode_visible, encode_loading, encode_presets, encode_preset, encode_directories, encoding:{price_per_gb}, selection_count} = this.state
        const {billing_modal_visible, focused, billing_loading, billing:{name, number, expiry, cvc}, slack_channels=[], slack_channel, share_on_slack}    = this.state
        const {block_ui, is_drop_disabled, is_drag_disabled} = this.props

        return (
            <BlockUi className='cloud-files-system'
                     blocking={new_folder_loading || accounts_loading || (files_loading && files.length > 0) || block_ui}>
                {
                    this.state.search_visible
                        ? <Search search_loading={search_loading} on_close={this.on_search_toggle} on_search={this.on_search} />
                        : <Header title=''
                                  files             = {this.state.files}
                                  on_create_folder  = {this.on_create_folder}
                                  on_move           = {this.on_move_files}
                                  on_refresh        = {()=>this.browse(bucket, this.state)}
                                  on_search_click={this.on_search_toggle} />
                }

                {/* <hr/> */}

                <NavigationControls
                    key                   = {'NavigationControls'}
                    files_loading         = {this.state.files_loading}
                    previous_path         = {this.state.previous_path}
                    files                 = {this.state.files}
                    on_navigate_back      = {this.on_navigate_back}
                    on_download           = {this.on_download}
                    on_delete             = {this.on_delete}
                    on_open_encode        = {this.on_open_encode}
                    on_move               = {this.on_move_files}
                    on_share              = {this.on_share}/>

                {/* <hr/> */}

                {create_folder ? ([<CreateFolder key={'CreateFolder'}
                                                 new_folder_name  = {this.state.new_folder_name}
                                                 on_create_folder = {this.on_create_folder}
                                                 on_change        = {this.on_new_folder_name_change}
                                                 on_cancel        = {this.on_cancel_create_folder}/>, <hr key={'hr'}/>])  : null}

                <Files
                    key               = {'Files'}
                    droppable_id      = {this.side || Math.random()}
                    is_drop_disabled  = {is_drop_disabled}
                    is_drag_disabled  = {is_drag_disabled}
                    selection_count   = {selection_count}
                    dragging_id       = {this.props.dragging_id}
                    files             = {bucket ? this.state.files : []}
                    files_loading     = {this.state.files_loading}
                    any_cloud_accounts= {this.state.cloud_accounts}
                    accounts_loading  = {this.props.any_cloud_accounts}
                    has_more          = {this.state.has_more_files}
                    user              = {this.props.user}

                    on_play_video     = {this.on_play_video}
                    on_delete         = {this.on_delete}
                    on_select         = {this.on_select}
                    on_download       = {this.on_download}
                    on_share          = {this.on_share}
                    on_open_encode    = {this.on_open_encode}
                    on_show_media_info= {this.on_show_media_info}
                    on_open_hybrik    = {this.on_open_hybrik}
                    on_expand_options = {this.on_expand_options}
                    on_refresh        = {()=>this.browse(bucket, this.state)}
                    on_navigate       = {this.on_navigate}
                    on_move           = {this.on_move_files}
                    on_load_more      = {this.on_load_more}/>

                {
                    this.state.share_visible &&
                    <Share files               = {this.state.share_files}
                           recipients          = {this.state.share_recipients}
                           visible             = {this.state.share_visible}
                           select_all          = {this.state.share_select_all}
                           loading             = {this.state.share_loading}
                           password            = {this.state.share_password}
                           expiration          = {this.state.share_expiration}
                           channels            = {slack_channels}
                           channel             = {slack_channel}
                           share_on_slack      = {share_on_slack}
                           use_weblink         = {this.props.use_weblink}
                           on_channel_change   = {this.on_slack_channel_change.bind(this)}
                           on_cancel           = {this.on_share_cancel}
                           on_select           = {this.on_share_select}
                           on_copy_link        = {this.on_copy_link}
                           on_generate_link    = {this.on_generate_link}
                           on_share_files      = {this.on_share_files}
                           on_recipient_change = {this.on_recipient_change}
                           on_password_change  = {this.on_share_password_change}
                           on_expiration_change= {this.on_share_expiration_change}
                           on_select_all       = {this.on_share_select_all}/>
                }

                {
                    encode_visible &&<Encode files               = {encode_files || []}
                                             visible             = {encode_visible}
                                             loading             = {encode_loading}
                                             presets             = {encode_presets}
                                             preset              = {encode_preset}
                                             directories         = {encode_directories}
                                             price_per_gb        = {price_per_gb}
                                             load_directories    = {this.load_directories}
                                             on_preset_change    = {this.on_preset_change}
                                             on_directory_change = {this.on_directory_change}
                                             on_add_coder_change = {this.on_add_coder_change}
                                             on_add_codec        = {this.on_add_codec}
                                             on_remove_preset    = {this.on_remove_preset}
                                             on_cancel    = {this.on_close_encode}
                                             on_encode    = {this.on_encode}/>
                }

                {
                    hybrik_visible &&
                    <CreateHybrikJob
                        visible={hybrik_visible}
                        dirs={encode_directories}
                        profiles={this.state.profiles || []}
                        definitions={this.state.definitions}
                        profileId={this.state.profile_id}
                        file={this.state.hybrik_file || {}}
                        pricePerGB={price_per_gb}
                        onDestChange={this.on_dest_change}
                        onDefChange={this.on_def_change}
                        onProfileChange={this.on_profile_change}
                        loadDirs={this.load_directories}
                        onEncode={this.on_hybrik_encode}
                        onCancel={this.on_close_hybrik}
                    />
                }

                {
                    billing_modal_visible &&
                    <PaymentForm title   = {''}
                                 ref     = {f=> this.form = f}
                                 visible = {billing_modal_visible}
                                 loading = {billing_loading}

                                 name    = {name}
                                 number  = {number}
                                 expiry  = {expiry||'##/##'}
                                 cvc     = {cvc}
                                 focused = {focused}

                                 on_cancel = {this.on_cancel_billing}
                                 on_save   = {this.on_save_billing}
                                 on_focus  = {this.on_focus}
                                 on_change = {this.on_billing_change}
                                 callback  = {this.billing_callback}
                    />
                }

                <MediaInfo ref={n=>this.media_info=n}/>

                <div className={'hidden'}>
                    {this.state.download_files.map((file, i)=> {
                        return <iframe key={i} download={file.url} src={file.url}/>
                    })}
                </div>
            </BlockUi>
        )
    }
}
